import React from 'react';
import Header from '../../components/Header/Header';
import Hero from '../../components/Hero/Hero';
import Activities from '../../components/Activities/Activities';
import News from '../../components/News/News';
import Footer from '../../components/Footer/Footer';
import './HomePage.css';

const HomePage = () => {
  return (
    <div className="home-page">
      <Header />
      <main>
        <Hero />
        <Activities />
        <News />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;